import { FC, useRef, useState } from 'react';
import styles from './index.less';
import NodeList from './nodeList';
import NodeContext from './nodeContext';
import NodeInfo from '@/pages/backend/cardCampSettings/nodeSettings/nodeInfo';

const NodeSettings: FC = () => {
  const listRef = useRef<any>(null);
  const [activeId, setActiveId] = useState<string | undefined>();
  const [activeIndex, setActiveIndex] = useState(0);
  const [nodeNameArray, setNodeNameArray] = useState<{ id: string; name: string }[]>([]);
  return (
    <NodeContext.Provider value={{ nodeNameArray }}>
      <div className={styles.node_settings}>
        <NodeList
          ref={listRef}
          onNameChange={(names) => {
            setNodeNameArray(names);
          }}
          activeId={activeId}
          onIndexChange={(index) => {
            setActiveIndex(index);
          }}
          onClick={(id, index, name) => {
            console.log('onClick触发', id, index);
            if (id !== activeId) {
              setActiveId(id);
            }
            setActiveIndex(index);
          }}
        />
        <div className={styles.node_settings_right}>
          <NodeInfo
            activeId={activeId}
            activeIndex={activeIndex}
            onActiveIdChange={(id, name) => {
              setActiveId(id);
              listRef?.current.reload();
            }}
          />
        </div>
      </div>
    </NodeContext.Provider>
  );
};
export default NodeSettings;
